import React, {useEffect, useState} from 'react';
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Autoplay, Pagination} from 'swiper/core';
import "swiper/swiper.min.css";

SwiperCore.use([Autoplay, Pagination])

export default function VerticalImageSlider(props) {

    const boxRef = React.createRef()
    const [pageWidth, setPageWidth] = useState(0)

    useEffect(() => {
        if (boxRef.current) {
            setPageWidth(boxRef.current.getBoundingClientRect().width)
        }
    }, [boxRef])

    if (props.sliders !== undefined) {
        let maxWidth = Math.max.apply(Math, props.sliders.map((slide) => {
            return slide.width
        }))
        let maxHeight = Math.max.apply(Math, props.sliders.map((slide) => {
            return slide.height
        }))
        let height = ((pageWidth * (maxWidth / 100)) * (maxHeight / 100))
        return (
            <div ref={boxRef} style={{height: height}}>
                <Swiper
                    pagination={true}
                    direction={'vertical'}
                    slidesPerView={1}
                    autoplay={{
                        "delay": 6000,
                        "disableOnInteraction": false
                    }}>
                    {props.sliders.map((slide, slideIndex) => {
                        if (pageWidth !== 0) {
                            return <SwiperSlide key={slideIndex}>
                                <img className="full"
                                     src={slide.image}
                                     onClick={() => {
                                         props.onClicked(props.sliders[slideIndex])
                                     }} alt={"صرفه مارکت"}/>
                            </SwiperSlide>
                        } else {
                            return null
                        }
                    })}
                </Swiper>
            </div>
        )
    } else {
        return (
            <div/>
        )
    }
}